// extracted by mini-css-extract-plugin
module.exports = {"container":"_9uiPh3xz","disclosureLink":"_2-liumHk","copy":"_1fdao2_f","fox":"_2JOUcCDU","thebalance1":"_3AykN9xn","investopedia1":"_1TtmyX1c","advertiserTooltip":"_1wBk0lxj"};